module.exports = __webpack_public_path__ + "img/channel-address-icon.d58150e9.png";